module.exports = __webpack_public_path__ + "img/012.32d2ad0b.jpg";